import { Object3D, Vector2, Vector3 } from 'three'
import Interactive from './Interactive'
import { GAME_OBJECTS } from './types'
import { Terrain } from '../../../d.controllers/TerrainController'
import TWEEN from '@tweenjs/tween.js'
import Minion from './Minion'
import { Battle } from '../../../d.controllers/BattleController'

export default class Candy extends Interactive {
  initialPosition: Vector3
  initialCoords: Vector2
  mana: number
  isPickable?: boolean
  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.CANDY)
    this.initialPosition = Terrain.coordsToPosition(obj.userData.coords)
    this.initialCoords = obj.userData.coords
    this.mana = 3
  }

  pickUp(who: Minion) {
    // already taken
    if (!this.isPickable) return false

    this.isPickable = false

    const TIME_FOR_PICK_ANIMATION = 500
    setTimeout(() => {
      this.obj.visible = false
      this.obj.position.copy(this.initialPosition)
      this.obj.userData.coords = this.initialCoords
      Terrain.removeObjectFromTerrain(this.obj)
  
      Battle.updateManaUnits(who.owner!, 1)
      // Battle.updateMana(who.owner!, this.mana)
  
      // unit recovers 25% of HP by picking candy up
      Battle.recoverUnitHP(who, 0.25)
    }, TIME_FOR_PICK_ANIMATION)
  }

  throwToFieldFrom(origin: Vector2) {
    Terrain.moveObject(this.obj, this.initialCoords)
    this.obj.position.copy(Terrain.coordsToPosition(origin))
    this.obj.visible = true
    // horizontal anim
    const destPosition = this.initialPosition
    new TWEEN.Tween(this.obj.position)
      .to(
        {
          x: destPosition.x,
          z: destPosition.z,
        },
        500,
      )
      .easing(TWEEN.Easing.Quintic.Out)
      .start()
    // vertical anim
    this.obj.position.y += 2
    new TWEEN.Tween(this.obj.position)
      .to(
        {
          y: 0,
        },
        500,
      )
      .easing(TWEEN.Easing.Bounce.Out)
      .onComplete(() => {
        this.isPickable = true
      })
      .start()

    // rotation
    const finalRotation = this.obj.rotation.y
    this.obj.rotation.y = 0
    new TWEEN.Tween(this.obj.rotation)
      .to(
        {
          y: finalRotation,
        },
        500,
      )
      .easing(TWEEN.Easing.Quintic.Out)
      .start()
  }
}
